import IAddressVm from "./IAddressVm"
import ICountryVm from "./ICountryVm"

import * as ICountryVmInstance from "./ICountryVm"
import * as IAddressVmInstance from "./IAddressVm"

export default interface ICitizenVm {
    id: string
    civilRegistrationIdentifier: string
    birthdate: string
    birthPlaceCountry: ICountryVm
    firstName: string
    lastName: string
    phone: string
    email: string
    address: IAddressVm
    secondDeliveryAddress: IAddressVm
    useSecondDeliveryAddress: boolean
    isNameAndAddressProtected: boolean
    isCitizenCreatedFromNemLoginClaims: boolean
    useCustomNameOnCertificate: boolean
    customFirstName: string
    customLastName: string
    nationality: ICountryVm
}

export const empty = (enableIteration: boolean = true): ICitizenVm => {
	return {
		id: "",
		civilRegistrationIdentifier: "",
		birthdate: "",
		birthPlaceCountry: ICountryVmInstance.empty(),
		firstName: "",
		lastName: "",
		phone: "",
		email: "",
		address: IAddressVmInstance.empty(),
		secondDeliveryAddress: IAddressVmInstance.empty(),
		useSecondDeliveryAddress: false,
		isNameAndAddressProtected: false,
		isCitizenCreatedFromNemLoginClaims: false,
		useCustomNameOnCertificate: false,
		customFirstName: "",
		customLastName: "",
		nationality: ICountryVmInstance.empty()
	} as ICitizenVm
}